import { reactive, type App } from 'vue';

import { modalKey } from '@/infra/injection-keys';

export { modalKey };

export interface ModalType {
  currentModal: string | null;
  show(name: string): void;
  hide(): void;
}

function createModalInstance(): ModalType {
  const state = reactive<{ currentModal: string | null }>({
    currentModal: null,
  });

  return {
    get currentModal() { return state.currentModal; },
    set currentModal(val: string | null) { state.currentModal = val; },
    show(name: string) {
      state.currentModal = name;
    },
    hide() {
      state.currentModal = null;
    },
  };
}

const _instance = createModalInstance();

export const modalPlugin = {
  _instance,
  install(app: App) {
    app.provide(modalKey, _instance);
  },
};
